import { jsx as e } from "react/jsx-runtime";
import { useToast as i } from "@chakra-ui/react";
import { SnackbarMessage as c } from "./components/useSnackbarMessage.es.js";
const w = () => {
  const o = i(), r = ({ duration: t, id: s, ...a }) => {
    const n = s ?? "toast-" + (/* @__PURE__ */ new Date()).getTime().toString();
    return o({
      duration: t,
      id: n,
      render: () => /* @__PURE__ */ e(c, { id: n, ...a }),
      containerStyle: {
        minWidth: "inherit"
      }
    });
  };
  return { error: (t) => r({ ...t, variant: "error" }), success: (t) => r({ ...t, variant: "success" }), warning: (t) => r({ ...t, variant: "warning" }), info: (t) => r({ ...t, variant: "info" }), default: r };
};
export {
  w as useSnackbar
};
//# sourceMappingURL=useSnackbar.es.js.map
